import React from "react";
import RelevantLinkBlock from "../fragments/RelevantLinkBlock";
import GalleryCarousel from "../fragments/GalleryCarousel";
import ContactLink from "../fragments/ContactLink";

export default function Article7() {
    let relevantUrls = [
        "/blog/8",
        "/vehicleOrder/catalog?vehicleCategory=CHN_ORDER",
        "/vehicleOrder/pricing",
        "/loan",
        "/listing",
    ];

    const carouselImages = [
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.16.jpeg",
            alt: "Geely Galaxy M9, серый цвет, вид спереди-сбоку в студии",
            caption: "Экстерьер: серый кузов и светодиодная оптика",
        },
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.20.jpeg",
            alt: "Geely Galaxy M9, чёрный цвет, вид спереди-сбоку, студийный свет",
            caption: "Экстерьер: чёрный силуэт и непрерывная LED-линия",
        },
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.22.jpeg",
            alt: "Панель Geely Galaxy M9 с панорамным дисплеем на всю торпедо",
            caption: "Интерьер: панорамный дисплей и аккуратная эргономика",
        },
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.25.jpeg",
            alt: "Передние сиденья Geely Galaxy M9, светлая кожа, вид сбоку",
            caption: "Салон: светлая кожа, удобная посадка",
        },
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.27.jpeg",
            alt: "Кресло водителя Geely Galaxy M9, перфорация и контурная прострочка",
            caption: "Комфорт: профильные кресла и тонкая прострочка",
        },
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.30.jpeg",
            alt: "Панорамная крыша Geely Galaxy M9, два стеклянных модуля",
            caption: "Свет: панорамная крыша для двух рядов",
        },
        {
            src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.33.jpeg",
            alt: "Второй ряд Geely Galaxy M9: раздельные кресла-капитаны с подлокотниками",
            caption: "Второй ряд: раздельные кресла-капитаны",
        },
    ];

    return (
        <div className="site-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-7 blog-content ml-auto order-lg-1">
                        <h2>Geely Galaxy M9 — о нём говорят. <br/>В наличии у нас, без долгого ожидания!</h2>

                        <div style={{textAlign: "justify"}}>
                            <img
                                src="/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.16.jpeg"
                                className="img-fluid py-2"
                                alt="Geely Galaxy M9"
                            />

                            <p>
                                Осень стучится в окно. Дни короче. Дороги холоднее. Хочется
                                мягко. Тихо. Тёпло. И без вечного «ждите поставку».
                            </p>
                            <p>
                                Решение — <strong>Geely Galaxy M9</strong>. Всеми обсуждаемый
                                гибрид-флагман из Китая. И главное — без ожидания на месяцы: авто
                                уже в дороге, приедет на днях!
                            </p>

                            <p>
                                <ContactLink>Свяжитесь с нами</ContactLink> — расскажем про комплектации, сроки на днях,
                                сориентируем по
                                кредитным/лизинговым программам.
                            </p>

                            <h4 className="mt-4">Чем хорош Galaxy M9?</h4>
                            <ul>
                                <li>
                                    ⚡ <strong>Драйв без стресса.</strong> <br/> Разгон 0–100 км/ч — 4,5
                                    с. Хватает, чтобы чувствовать запас в любой ситуации.
                                </li>
                                <li>
                                    🔋 <strong>Умный гибрид DHT (4 режима):</strong>
                                    <br/>• <em>EV</em> — едете на электротяге, тишина и экономия;
                                    <br/>• <em>Последовательный</em> — ДВС заряжает электромотор;
                                    <br/>• <em>Параллельный</em> — ДВС + электромотор вместе для
                                    тяги;
                                    <br/>• <em>Прямой привод ДВС</em> — на скоростях выше 40 км/ч
                                    для лучшей эффективности.
                                </li>
                                <li>
                                    🛞 <strong>Комфорт осенью.</strong> <br/> Воздушная подвеска, полный
                                    привод, манёвренность с «танковым разворотом».
                                </li>
                                <li>
                                    👨‍👩‍👧 <strong>Семейный простор.</strong> <br/> Кожа. Тишина. База
                                    3030 мм — всем хватит места.
                                </li>
                            </ul>

                            <h4 className="mt-4">То, что важно в городе и на трассе:</h4>
                            <ul>
                                <li>
                                    Три электромотора + 1.5T (163 л.с.); суммарно —{" "}
                                    <strong>707 л.с.</strong>
                                </li>
                                <li>3-ступенчатая DHT, полный электропривод всех колёс.</li>
                                <li>Габариты: 5205×1999×1800 мм. Масса 2530 кг.</li>
                                <li>Батарея: 41,46 кВт·ч. Бак 60 л.</li>
                                <li>Шины: 255/50 R20.</li>
                                <li>
                                    Подвеска: спереди — двойные рычаги, сзади — многорычажная.
                                </li>
                                <li>Максималка: 210 км/ч.</li>
                            </ul>

                            <GalleryCarousel images={carouselImages} height={{xs: 240, md: 420}}/>

                            <p className="mt-4">Осень🍁 — не про «потом». Осень — про «ехать сейчас»🙌</p>
                            <p className="mt-3">
                                Готовы обсудить комплектацию и забронировать авто из первой поставки?<br/>
                                <ContactLink>
                                    Хочу Galaxy M9 без ожидания →
                                </ContactLink>
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 order-lg-2">
                        <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
